// Tenant-facing inbox: every request someone has sent to me. The detail
// page (#/tenant-requests/:id) does the heavy lifting (uploads, history);
// this view is a thin chronological list grouped by status.

import { Component, esc } from '../core/component.js';
import { api, ApiError } from '../core/api.js';
import { formatDate } from '../core/format.js';
import { icon } from '../core/icons.js';
import { t } from '../core/i18n.js';

const STATUS_ORDER = ['SENT', 'IN_REVIEW', 'APPROVED', 'CANCELLED'];

export class TenantRequestsInboxView extends Component {
  constructor() {
    super();
    this.state = { rows: null, error: null };
  }

  template() {
    const rows = this.state.rows;
    return `
      <section class="stack">
        <div class="row-between">
          <h2>${esc(t('tenant_requests.inbox.title'))}</h2>
          <a href="#/tenant-requests/outgoing" class="btn btn-ghost">
            ${icon('arrow-right', { size: 'sm' })}<span>${esc(t('tenant_requests.outgoing.link'))}</span>
          </a>
        </div>
        ${this.state.error ? `<div class="error-banner">${esc(this.state.error)}</div>` : ''}
        ${rows === null
          ? `<div class="muted">${esc(t('common.loading'))}</div>`
          : rows.length === 0
            ? `<div class="empty">${esc(t('tenant_requests.inbox.empty'))}</div>`
            : this._listHtml(rows)}
      </section>
    `;
  }

  _listHtml(rows) {
    const sorted = [...rows].sort((a, b) => {
      const ai = STATUS_ORDER.indexOf(a.status); const bi = STATUS_ORDER.indexOf(b.status);
      if (ai !== bi) return ai - bi;
      return String(b.sent_at || b.created_at || '').localeCompare(String(a.sent_at || a.created_at || ''));
    });
    return `<div class="list">${sorted.map((r) => this._rowHtml(r)).join('')}</div>`;
  }

  _rowHtml(r) {
    const due = r.due_at ? formatDate(String(r.due_at).slice(0, 10)) : null;
    const requester = r.requester_name || r.requester_email || '';
    return `
      <a class="list-item" href="#/tenant-requests/${esc(r.id)}">
        ${icon('inbox', { class: 'list-leading icon-faint' })}
        <div class="stack-2 grow">
          <strong>${esc(r.title)}</strong>
          <span class="faint">${esc(t('tenant_requests.row.from', { who: requester }))}${due ? ' · ' + esc(t('tenant_requests.row.due', { date: due })) : ''}</span>
        </div>
        <span class="badge">${esc(r.status)}</span>
        ${icon('chevron-right', { class: 'icon-faint' })}
      </a>
    `;
  }

  mount() {
    if (this.state.rows === null) this._load();
  }

  async _load() {
    try {
      const r = await api.get('/tenant-requests/incoming');
      this.setState({ rows: r.data || [] });
    } catch (err) {
      this.setState({ error: err instanceof ApiError ? err.message : t('tenant_requests.errors.load') });
    }
  }
}
